import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "stringReplace",
  standalone: true,
})
export class StringReplacePipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    search: string,
    replace: string = "",
  ): string {
    if (value === null || value === undefined) {
      return "";
    }

    if (typeof value !== "string") {
      return String(value);
    }

    // Handle HTML entities like &nbsp;
    const searchPattern = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(searchPattern, "g");

    return value.replace(regex, replace);
  }
}
